import { createApp } from 'vue'
import TimeZoneDifference from './TimeZoneDifference.vue'
import './assets/global.css'

createApp(TimeZoneDifference).mount('#time-zone-difference')
